var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "legend-item-with-dropdown" }, [
    _c("div", [
      _c("label", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.checkboxState,
              expression: "checkboxState",
            },
          ],
          staticClass: "legend-checkbox",
          attrs: { type: "checkbox" },
          domProps: {
            checked: Array.isArray(_vm.checkboxState)
              ? _vm._i(_vm.checkboxState, null) > -1
              : _vm.checkboxState,
          },
          on: {
            change: function ($event) {
              var $$a = _vm.checkboxState,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.checkboxState = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.checkboxState = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.checkboxState = $$c
              }
            },
          },
        }),
        _vm._v(" " + _vm._s(_vm.layer.group_name) + "\n        "),
      ]),
    ]),
    _vm._v(" "),
    _vm.checkboxState
      ? _c("div", { staticClass: "dropdown-item-below-title" }, [
          _c("div", [
            _vm.layer.local_legend_ref
              ? _c("img", {
                  attrs: {
                    alt: "Fishing activity legend",
                    src: _vm.layer.local_legend_ref,
                  },
                })
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectorState,
                    expression: "selectorState",
                  },
                ],
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.selectorState = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                },
              },
              _vm._l(_vm.layer.layers, function (sublayer) {
                return _c(
                  "option",
                  { domProps: { value: sublayer.layer_name } },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(sublayer.layer_name_display) +
                        "\n                "
                    ),
                  ]
                )
              }),
              0
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }